import React from 'react';

import { Trans } from 'react-i18next';

import v from 'components/variables';

export const TRACK_BOARD_VIEW_KEY = 'TRACK_BOARD_VIEW_KEY';
export const LIST_VIEW_KEY = 'LIST_VIEW_KEY';

export const HEADER_SEGMENTED_CONTROL_BUTTONS = [
  {
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Board" />
    ),
    buttonValue: TRACK_BOARD_VIEW_KEY,
  },
  {
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.List" />
    ),
    buttonValue: LIST_VIEW_KEY,
  },
];

export const COMMON_APP_FERPA_PENDING_DESCRIPTION = (
  <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.StudentFERPANotCompleted" />
);

export const FERPA_PENDING_COMMON_APP_STEPS = [
  <Trans
    key="CollegeApplicationManager.ApplicationTrackBoardConstants.LoginCommonAppAccount"
    i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.LoginCommonAppAccount"
  />,
  <Trans
    key="CollegeApplicationManager.ApplicationTrackBoardConstants.ClickSection"
    i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.ClickSection"
  />,
  <Trans
    key="CollegeApplicationManager.ApplicationTrackBoardConstants.ReviewInstructions"
    i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.ReviewInstructions"
  />,
];

export const WILL_NOT_COMPLETE_STATUS = -1;
export const IN_PROGRESS_STATUS = 0;
export const COMPLETED_STATUS = 1;
export const WAITLISTED_STATUS = 2;
export const DEFERRED_STATUS = 3;
export const ACCEPTED_STATUS = 4;
export const WITHDRAWN_STATUS = 5;
export const REJECTED_STATUS = 6;

export const INCOMPLETE_STATUSES = [IN_PROGRESS_STATUS];
export const COMPLETE_AND_PENDING_STATUSES = [
  COMPLETED_STATUS,
  WAITLISTED_STATUS,
  DEFERRED_STATUS,
];
export const COMPLETE_PENDING_AND_RESULT_STATUSES = [
  COMPLETED_STATUS,
  WAITLISTED_STATUS,
  DEFERRED_STATUS,
  ACCEPTED_STATUS,
  REJECTED_STATUS,
];
export const ACCEPTED_STATUSES = [ACCEPTED_STATUS];
export const WITHDRAWN_STATUSES = [WITHDRAWN_STATUS];
export const DECLINED_STATUSES = [REJECTED_STATUS];
export const WILL_NOT_COMPLETE_STATUSES = [WILL_NOT_COMPLETE_STATUS];

export const INCOMPLETE_KEY = 'incomplete';
export const COMPLETED_PENDING_KEY = 'completed_pending';
export const ACCEPTED_KEY = 'accepted';

export const COLUMN_TITLE_INFO = {
  [INCOMPLETE_KEY]: {
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Incomplete" />
    ),
    countColor: 'red',
    description: (
      <>
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EditAnApplicationBelow" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.RequestRecommendations" />
        </b>{' '}
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Or" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.UpdateChecklist" />
        </b>
        .
      </>
    ),
    emptyText: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.IncompleteEmptyText" />
    ),
    popoverText: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.IncompletePopoverText" />
    ),
  },
  [COMPLETED_PENDING_KEY]: {
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.CompletePending" />
    ),
    countColor: 'orangeDark',
    description: (
      <>
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.SelectCompletedApplication" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.UpdateResults" />
        </b>{' '}
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Or" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.TrackDocuments" />
        </b>
        .
      </>
    ),
    emptyText: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.CompletePendingEmptyText" />
    ),
    popoverText: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.CompletePendingPopoverText" />
    ),
  },
  [ACCEPTED_KEY]: {
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Accepted" />
    ),
    countColor: 'greenDark',
    description: (
      <>
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.BeSureUpload" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.AwardLetters" />
        </b>{' '}
        <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.AndAddAn" />{' '}
        <b>
          <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EnrollmentDecision" />
        </b>
        .
      </>
    ),
    emptyText: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.AcceptedEmptyText" />
    ),
  },
};

export const TARGET_KEY = 'target';
export const LIKELY_KEY = 'likely';
export const REACH_KEY = 'reach';
export const FAR_REACH_KEY = 'far_reach';

export const APPLICATION_TYPE_OPTIONS = [
  {
    id: 'REGULAR_DECISION',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.RegularDecision" />
    ),
    icon: 'circle',
  },
  {
    id: 'ROLLING',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Rolling" />
    ),
    icon: 'square',
  },
  {
    id: 'PRIORITY',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Priority" />
    ),
    icon: 'circle-with-peaks',
  },
  {
    id: 'EARLY_ACTION',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EarlyAction" />
    ),
    icon: 'star',
  },
  {
    id: 'EARLY_ACTION_2',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EarlyAction2" />
    ),
    icon: 'star',
  },
  {
    id: 'EARLY_DECISION',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EarlyDecision" />
    ),
    icon: 'triangle',
  },
  {
    id: 'EARLY_DECISION_2',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.EarlyDecision2" />
    ),
    icon: 'rhombus',
  },
  {
    id: 'RESTRICTED_EARLY_ACTION',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.RestrictedEarlyAction" />
    ),
    icon: 'hexagon',
  },
  {
    id: 'OTHER',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Other" />
    ),
    icon: 'cloud',
  },
];

export const COMMON_APP_NAME = 'Common App';

export const STATUS_MAP = Object.freeze({
  [ACCEPTED_STATUS]: {
    emoji: '😀 ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Accepted" />
    ),
    color: v.greenExtraLight,
    sortValue: 0,
  },
  [DEFERRED_STATUS]: {
    emoji: '⌛ ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Deferred" />
    ),
    color: v.orangeExtraLight,
    sortValue: 1,
  },
  [WAITLISTED_STATUS]: {
    emoji: '🕓 ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Waitlisted" />
    ),
    color: v.orangeExtraLight,
    sortValue: 2,
  },
  [COMPLETED_STATUS]: {
    emoji: '❓ ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.CompletedPending" />
    ),
    color: v.yellowExtraLight,
    sortValue: 3,
  },
  [IN_PROGRESS_STATUS]: {
    emoji: '✏ ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.InProgress" />
    ),
    color: v.blueSteelExtraLight,
    sortValue: 5,
  },
  [WITHDRAWN_STATUS]: {
    emoji: '📤 ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Withdrawn" />
    ),
    color: v.grayLight,
    sortValue: 4,
  },
  [WILL_NOT_COMPLETE_STATUS]: {
    emoji: '❌ ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.WontComplete" />
    ),
    color: v.grayExtraLight,
    sortValue: 7,
  },
  [REJECTED_STATUS]: {
    emoji: '😕 ',
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Denied" />
    ),
    color: v.redExtraLight,
    sortValue: 6,
  },
});

export const ADD_COLLEGE_STATUS_LIST = [
  {
    id: IN_PROGRESS_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.InProgress" />
    ),
    emoji: '✏️',
  },
  {
    id: COMPLETED_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.CompletedPending" />
    ),
    emoji: '❓',
  },
  {
    id: ACCEPTED_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Accepted" />
    ),
    emoji: '😃',
  },
  {
    id: REJECTED_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Denied" />
    ),
    emoji: '😕',
  },
  {
    id: WAITLISTED_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Waitlisted" />
    ),
    emoji: '🕓',
  },
  {
    id: DEFERRED_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Deferred" />
    ),
    emoji: '⌛',
  },
  {
    id: WITHDRAWN_STATUS,
    label: (
      <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.Withdrawn" />
    ),
    emoji: '📤',
  },
];

/** @todo remove it and use COLLEGE_APPLICATIONS_ONBOARDING insider userBooleans  */
export const COLLEGE_APPLICATIONS_ONBOARDING_BOOLEAN =
  'college_applications_onboarding';

export const EMPTY_SEARCH_TEXTS = {
  [INCOMPLETE_KEY]: (
    <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.NoIncompleteApplications" />
  ),
  [COMPLETED_PENDING_KEY]: (
    <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.NoCompletedApplications" />
  ),
  [ACCEPTED_KEY]: (
    <Trans i18nKey="CollegeApplicationManager.ApplicationTrackBoardConstants.NoAcceptedApplications" />
  ),
};

export const SORT_FIELDS = Object.freeze({
  COLLEGE_NAME: 'college_name',
  DUE_DATE: 'submission_due_date',
  STATUS: 'status',
});
